import { Component as ComponentObject } from '@pershing/pershing-site-metadata';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';
import { ComponentListService } from '../services/component-list.service';
import { cloneDeep } from 'lodash';
import { PageStateService } from '../services/page-state.service';

@Component({
    selector: 'add-component-dialog',
    template: `<div mat-dialog-title>
	<h1>Select Component</h1>
	<button mat-dialog-close type="button" class="close" aria-label="Close" tabindex="-1" (click)="onCancel()"><span aria-hidden="true">&times;</span></button>
</div>
<div mat-dialog-content>
	<div class="mat-dialog-content-padded">

		<mat-radio-group (change)="onChange($event)">
					<table class="table">
						<tr class="border-bottom" *ngFor="let component of componentObjects">
							<td style="vertical-align: top"><mat-radio-button [value]="component" class="margin-right-0"></mat-radio-button></td>
							<td><h3 class="no-margin"><b>{{component.displayName}}</b></h3>
								<p> {{component.description}} </p></td>
						</tr>
					</table>
		</mat-radio-group>
	</div>
</div>
<div mat-dialog-actions>
	<div class="action-buttons">
		<button mat-stroked-button class="small-button secondary-action" color="primary" (click)="onCancel()">Cancel</button>
		<button mat-raised-button class="small-button" color="primary" [disabled]="!selectedComponent" (click)="onConfirm()" cdkFocusInitial>Add Component</button>
	</div>
</div>`
})
export class AddComponentDialog implements OnInit {

    selectedComponent: ComponentObject;
    componentObjects: ComponentObject[];
    componentId: string;

    constructor(public dialogRef: MatDialogRef<AddComponentDialog>,
                @Inject(MAT_DIALOG_DATA) public data: any,
                public componentListService: ComponentListService,
                private pageEditState: PageStateService) { }

    ngOnInit() {
        // if (!this.editLibraryOptions.generateComponentId) {
        this.componentListService.generateComponentId()
            .subscribe((componentId) => {
                this.componentId = componentId;
            });
        // }
        this.componentListService.retrieveComponents()
            .subscribe(response => {
                if (response) {
                    this.componentObjects = this.pageEditState.removeComponentsFromList(response);
                }
            });
    }

    onChange($event: MatRadioChange) {
        this.selectedComponent = $event.value;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm(): void {
        let component = cloneDeep(this.selectedComponent);
        const componentId = component.componentId || this.componentId || this._rng();
        component.componentId = componentId;
        this.populateSystemGeneratedProperties(component);

        // TODO: Remove these
        // added for compatability
        component.selector = component.componentSelector;
        if (component.domProperties) {
            component.input = component.domProperties.reduce((inputs, obj) => {
                if (obj.value) {
                    inputs[obj.attributeName] = obj.value;
                }
                return inputs;
            }, {});
        } else if (component.properties) {
            // this is added for backwards compatibility with the dashboard
            // dashboard json: https://qa-www.pllcfiles.inautix.com/staticartifacts/@pershing/nxp-portal-common@7.1.0-SNAPSHOT/src/assets/component-registry-legacy.json
            component.input = component.properties;
        }
        this.data.component = component;
        this.data.id = componentId;
        this.dialogRef.close(this.data);
    }

    _rng(): string {
        return Math.random().toString().replace('.', '');
    }

    generateSystemContext(component: ComponentObject) {
        let context = {
            componentId: component.componentId,
            domain: 'domain'
        };
        return context;
    }
    populateSystemGeneratedProperties(component: ComponentObject) {
        // TODO: change ${Context.componentId} to ${componentId}
        let Context = this.generateSystemContext(component);
        if (component.domProperties) {
            for (let prop of component.domProperties) {
                if (prop.defaultValue) {
                    // Apply default value to property
                    let value = prop.defaultValue;
                    prop.value = value;
                    let [TK_OPEN, TK_CLOSE] = ['${', '}'];
                    if (value.includes(TK_OPEN)) {
                        // Apply system generated value to property
                        let [start, end] = [value.indexOf(TK_OPEN) + 2, value.indexOf(TK_CLOSE)];
                        let key = value.substring(start, end);
                        let keys = key.split('.');
                        if (Context && keys.length > 1 && Context[keys[1]]) {
                            prop.value = value.replace(TK_OPEN + key + TK_CLOSE, Context[keys[1]]);

                        }
                    }
                }
            }
        }
    }
}
